import request from "@/api/request";

class FeatureService {
  static async setOrganicData(age: string, source: string, other_source: string | null): Promise<void> {
    return await request.post("/feature/set_organic_data", {
      age,
      source,
      other_source,
    });
  }

  static async addFeedback(props: { text: string; subject: string }): Promise<void> {
    return await request.post(`/feature/feedback`, props);
  }

  static async getFeatureFeedback(feature: string): Promise<void> {
    return await request.get(`/feature/feature_feedback/${feature}`);
  }

  static async setFeatureFeedback(feature: string, rating: number, message: string): Promise<void> {
    return await request.post(`/feature/feature_feedback/${feature}`, { rating, message });
  }

  static async getCompany(): Promise<string> {
    return await request.post(`/feature/get_company`);
  }

  static async closeFeatureFeedback(feature: string): Promise<void> {
    return await request.delete(`/feature/feature_feedback/${feature}`);
  }

  static async setViewed(feature: string): Promise<void> {
    await request.post(`/feature/view/${feature}`);
  }

  static async getModelTipOfferPopup(): Promise<void> {
    return await request.get(`/feature/model_tip_offer`);
  }

  static async trackAction(feature: string, action: string): Promise<void> {
    await request.post(`/feature/track_action/${feature}`, { action });
  }
}

export default FeatureService;
